import React from 'react';
import { Checkbox } from '@mui/material';
import CheckedXIcon from '@shared/components/CheckedXIcon';

/**
 * @typedef {object} ViewInvoicesCheckboxProps
 * @property {boolean} checked
 * @property {(event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void} onChange
 * @property {boolean} [disabled]
 */

/**
 * @param {ViewInvoicesCheckboxProps} props
 */
const ViewInvoicesCheckbox = props => {
  const { checked, onChange, disabled = false } = props;
  return (
    <div className='checkbox-wrapper'>
      <h4 className='field-title'>View Invoices</h4>
      <Checkbox
        id='view-invoices-checkbox'
        data-testid='view-invoices-checkbox'
        inputProps={{
          'data-testid': 'view-invoices-checkbox-input'
        }}
        size='small'
        checked={checked}
        checkedIcon={<CheckedXIcon size='small' />}
        onChange={onChange}
        color='default'
        disabled={disabled}
      />
    </div>
  );
};

export default ViewInvoicesCheckbox;
